import type { TOC } from '@ember/component/template-only'
import type { WithBoundArgs } from '@glint/template'
import { hash } from '@ember/helper'
import { BasicTableRow } from 'teacher-ui-client/components/stable-table/basic-table/row'
import type { ColumnObject } from 'teacher-ui-client/components/stable-table/basic-table/cell'
import type { Config } from 'teacher-ui-client/components/stable-table/basic-table'

interface HeadSignature {
  Element: HTMLTableSectionElement
  Args: {
    columns: ColumnObject[]
    config?: Config
  }
  Blocks: {
    default: [{ row: WithBoundArgs<typeof BasicTableRow, 'rowObject' | 'columns' | 'isHeader' | 'config'> }]
  }
}

/**
 * Very similar to body component, just using <thead/> and creating a single rowObject out of the columns
 */
export const BasicTableHead: TOC<HeadSignature> = <template>
  <thead data-test-basic-table-head ...attributes>
    {{#let
      (component BasicTableRow rowObject=(hash cells=@columns) columns=@columns isHeader=true config=@config)
      as |row|
    }}
      {{#if (has-block)}}
        {{yield (hash row=row)}}
      {{else}}
        {{row}}
      {{/if}}
    {{/let}}
  </thead>
</template>

export default BasicTableHead
